var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFromRego),expression:"isFromRego"}],staticClass:"dta-container styled-form__info styled-form__info--bg-1 text--center",domProps:{"innerHTML":_vm._s(_vm.info)}})
}
var staticRenderFns = []

export { render, staticRenderFns }